import { isProd } from '@/common';
import { PATHS } from './paths';

export const FOOTER_ITEMS = [
  { label: 'footer.termsAndConds', link: `/${PATHS.TERMS_AND_CONDITIONS}` },
  { label: 'footer.privacy', link: `/${PATHS.PRIVACY}` },
  { label: 'footer.imprint', link: `/${PATHS.IMPRINT}` },
  { label: 'footer.claudeConnector', link: `/${PATHS.CLAUDE_CONNECTOR}` },
  !isProd && { label: 'footer.about', link: `/${PATHS.ABOUT}` },
  !isProd && { label: 'footer.blog', link: `/${PATHS.BLOG}` },
  !isProd && { label: 'footer.services', link: `/${PATHS.SERVICES}` },
  !isProd && { label: 'footer.extraCharges', link: `/${PATHS.EXTRA_CHARGES}` },
].filter(Boolean) as {
  label: string;
  link: string;
}[];
